import React from "react";
import { Flex, Typography } from "antd";
import { FIELD_TYPES } from "../../../domain/clinicalForms";
import PillTag from "./PillTag";
import renderValue from "./renderValue";
import { isOptionField, selectedOptions } from "./utils";
import { nestedGroupBorder } from "./styles";

const SubFieldItem = ({ field, values, showLabel = true }) => {
  if (field.type === FIELD_TYPES.SECTION_HEADER) return null;
  const value = values[field.id];
  const directSubs = field.sub_questions || [];
  const options = isOptionField(field) ? selectedOptions(field, value) : [];
  const anyOptionHasSubs = options.some((o) => o?.sub_questions?.length);
  const topGap = showLabel ? 4 : 0;

  return (
    <Flex vertical gap={8}>
      {showLabel && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {field.label || "Untitled"}
        </Typography.Text>
      )}

      {anyOptionHasSubs ? (
        <Flex wrap gap={12} style={{ marginTop: topGap }}>
          {options.map((opt) => (
            <Flex
              key={opt.value}
              vertical
              gap={6}
              style={{ flex: "1 1 220px", minWidth: 200 }}
            >
              <PillTag style={{ alignSelf: "flex-start" }}>
                {opt.label}
              </PillTag>
              {opt.sub_questions?.length > 0 && (
                <Flex vertical gap={8} style={nestedGroupBorder}>
                  {opt.sub_questions.map((sub) => (
                    <SubFieldItem key={sub.id} field={sub} values={values} />
                  ))}
                </Flex>
              )}
            </Flex>
          ))}
        </Flex>
      ) : (
        <div style={{ marginTop: topGap }}>{renderValue(field, value)}</div>
      )}

      {directSubs.length > 0 && (
        <Flex vertical gap={8} style={nestedGroupBorder}>
          {directSubs.map((sub) => (
            <SubFieldItem key={sub.id} field={sub} values={values} />
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default SubFieldItem;
